// @flow
import React, { useMemo } from 'react';

import Link from 'app/common/lib/link';
import { toFixedValueCurrency } from 'app/common/lib/toFixedValue';
import Price from 'app/common/layouts/commonShop/Price';
import { DotsLoader } from 'app/common/components/Loader';

import styles from './CatalogProduct.module.scss';;


type Props = {
  title: string,
  imgSrc?: string,
  price: number,
  link?: string,
  loading?: boolean,
}

const CatalogProduct = ({ title, imgSrc, price, link = '', loading }: Props) => {
  const priceString = useMemo(() => toFixedValueCurrency(price, true), [price]);
  return (
    <div className={styles.root}>
      <div className={styles.image}>
        <Link to={link}>
          <img src={imgSrc} alt={title} />
        </Link>
      </div>
      <div className={styles.title}>
        <Link to={link}>
          {title}
        </Link>
      </div>
      <Price className={styles.price}>
        <Link to={link}>
          {priceString}
        </Link>
      </Price>
      {loading && <div className={styles.loaderContainer}>
        <DotsLoader className={styles.loader} />
      </div>}
    </div>
  );
};

export default CatalogProduct;
